export function SET_FILTERS({ commit }, [progress, search, selected_areas, selected_groups, selected_tags]) {
    commit('SAVE_FILTERS', [progress, search, selected_areas, selected_groups, selected_tags])
}

export function SET_PRESENTIAL_STATUS({ commit }, [presential_status]) {
    commit('SAVE_PRESENTIAL_STATUS', [presential_status])
}

export function SET_PRESENTIAL_IS_ONLINE({ commit }, [presential_is_online]) {
    commit('SAVE_PRESENTIAL_IS_ONLINE', [presential_is_online])
}

export function SET_PROGRESS({ commit }, progress) {
    commit('SAVE_PROGRESS', progress)
}

export function SET_FILTER_AREA({ commit }, selected_areas) {
    commit('SAVE_FILTER_AREA', selected_areas)
}

export function SET_LOADING({ commit }, loading) {
    commit('SAVE_LOADING', loading)
}